const inventoryEn = {
    inward: require('../../lang/en/inventory/Inward').default,
    stockAvailability: require('../../lang/en/inventory/StockAvailability').default,
    pricing: require('../../lang/en/inventory/Pricing').default,
    outward: require('../../lang/en/inventory/Outward').default,
};

export default inventoryEn;